import { render } from "./DGPO.vue?vue&type=template&id=21efee96&scoped=true"
import script from "./DGPO.vue?vue&type=script&lang=js"
export * from "./DGPO.vue?vue&type=script&lang=js"

import "./DGPO.vue?vue&type=style&index=0&id=21efee96&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21efee96"]])

export default __exports__